import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-my-timesheets',
  templateUrl: './my-timesheets.component.html'
})
export class MyTimesheetsComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/modules/time/components/my-timesheets/my-timesheets.component.ts